import {NgModule} from "@angular/core";
import {ContactSearchPageComponent} from "../contact/contact-search-page/contact-search-page.component";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {ContactEditPageComponent} from "../contact/contact-edit-page/contact-edit-page.component";
import {ContactEditAccountsComponent} from "../contact/contact-edit-page/contact-edit-accounts/contact-edit-accounts.component";
import {ContactSharedModule} from "./contact.shared.module";
import {AccountSharedModule} from "../accounts/account.shared.module";
import {ContactEditDeliveryTakeawayComponent} from "./contact-edit-page/contact-edit-delivery-takeaway/contact-edit-delivery-takeaway.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        ContactSharedModule,
        AccountSharedModule
    ],
    declarations: [
        ContactSearchPageComponent,
        ContactEditPageComponent,
        ContactEditAccountsComponent,
        ContactEditDeliveryTakeawayComponent
    ],
    exports: [
        ContactSearchPageComponent,
        ContactEditPageComponent
    ]
})
export class ContactModule {
}
